import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { selectActiveVariant } from '@ff-scene-plugins/gift-redux/selectors/variantSelectors';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';

export const toOutputs = (state: GiftPdpState): Pdp.Scene.Output[] => {

    const activeVariant = selectActiveVariant(state);

    return [
        {
            cuid: state.project.cuid,
            sku: activeVariant.externalId,
            quantity: 1
        }
    ];
};